import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'license_plate_id': 'Int!',
	'employee_booking_guid': '[String]!',
	'validate': 'Boolean!'
};

export default gql(`
	mutation license_plate_validate( ${ HelperGraphql.createFields( fields ) } ) {
	    license_plate_validate( ${ HelperGraphql.createVariables( fields ) } ) {
	        license_plate
	        validated
	    }
	}
`);

